// extracted by mini-css-extract-plugin
export var productImage = "_qe-1";
export var viewLink = "_qe-2";
export var wishlistItem = "_qe-0";